const chains = [];
chains.push({ _operation: 'getCentralSheetRecordsByExternalPartyIdAndSaleType', api: '/central-sheet-records/:externalPartyId/:saleType', defaultData: [], httpVerb: 'get' });
export default chains;
